import { COLORS } from '@btime/constants'
import { getExtension } from '@btime/helpers'
import React from 'react'

import { HorizontalLine } from '../../shapes/Line'
import { Text } from '../Text'
import { Thumb } from '../Image'
import { useGalleryActions, useGalleryState } from './GalleryHandler'
import Border from '../../helpers/Border'
import Center from '../../helpers/Center'
import DocumentThumb from './DocumentThumb'
import Icon from '../../shapes/Icon'
import Link from '../../actions/Link'
import SeparatorWrapper from '../../helpers/SeparatorWrapper'
import Tooltip from '../../helpers/Tooltip'
import { Relative } from '../../../packages/kiti/components/helpers/Position'

const ItemThumb = ({ item, src, height, children }) => {
  if (item.isImage || item.type === 'video') {
    return (
      <Thumb height={height} src={src} type={item.type}>
        {children}
      </Thumb>
    )
  }

  const extension = getExtension(item.value)

  return (
    <DocumentThumb height={height} extension={extension}>
      {children}
    </DocumentThumb>
  )
}

const GalleryItemThumb = ({ item, thumbHeight }) => {
  const { canRemove } = useGalleryState()
  const { setSelected, handleRemove } = useGalleryActions()
  const handleOnSelect = item => () => setSelected(item)

  return (
    <Link block onClick={handleOnSelect(item)}>
      <Border>
        <Relative>
          <ItemThumb item={item} height={thumbHeight || '10rem'} src={item.value}>
            {!!canRemove && (
              <Link onClick={handleRemove(item, item.index)}>
                <Center>
                  <Icon name="BsX" color={COLORS.red} />
                </Center>
              </Link>
            )}
          </ItemThumb>
        </Relative>

        <HorizontalLine thin lineColor={COLORS.light2} />
        {item.label && (
          <SeparatorWrapper weight={4} usePadding>
            <Tooltip actionContent={<Text hideOverflow>{item.label}</Text>}>
              <Text>{item.label}</Text>
            </Tooltip>
          </SeparatorWrapper>
        )}
      </Border>
    </Link>
  )
}

export default GalleryItemThumb
